// "YYYY-MM" or "YYYY" → Date (first of month, midnight UTC)
export function parseDateString(s: string | null | undefined): Date | null {
  if (!s) return null;
  const parts = s.split("-");
  const year = parseInt(parts[0], 10);
  const month = parts[1] ? parseInt(parts[1], 10) : 1;
  return new Date(Date.UTC(year, month - 1, 1));
}

// Resolve "ongoing" (null) end dates to "now" for layout purposes
export function endOrNow(end: Date | null): Date {
  return end ?? new Date();
}

export function formatYearMonth(date: Date): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}

export function formatYear(date: Date): string {
  return String(date.getUTCFullYear());
}
